// extracted by mini-css-extract-plugin
export default {"container":"container__R7F7g","title":"title__L_C_b","greeting":"greeting__HXhQz","headerLeft":"headerLeft__t6Ynk"};